import React, { useCallback } from 'react';
import { ReactComponent as File } from '../../../src/assets/svg/file.svg';
import { ReactComponent as HddVerifiedTrue } from '../../../src/assets/svg/hddVerifiedTrue.svg';
import { ReactComponent as HddVerifiedFalse } from '../../../src/assets/svg/hddVerifiedFalse.svg';

import RecordHDDContents from './modals/projects/recordHDDContents';
const Tree = ({
	props,
	data = props.data,
	toggled = true,
	name = null,
	isLast = true,
	i = 0,
	info = null,
	isChildElement = false,
	isParentToggled = false,
	hardDrive = props.hardDrive,
	hardDriveID = props.hardDriveID,
	contents = props.contents,
	createdBy = props.createdBy,
	path = null,
}) => {
	const [isToggled, setIsToggled] = React.useState(toggled);
	const [showModal, setShowModal] = React.useState(false);
	const [constPath, setPath] = React.useState(null);
	const isDataArray = Array.isArray(data);
	const [constHardDrive] = React.useState(hardDrive);
	const [constHardDriveID] = React.useState(hardDriveID);
	const [constContents] = React.useState(contents);
	const [constCreatedBy] = React.useState(createdBy);

	const handleClick = function (path) {
		setPath(path);
		setShowModal(true);
	};

	return (
		<>
			<div
				className={`tree-element ${isParentToggled && 'tree-collapsed'} ${
					isChildElement && 'is-child'
				} ${name == null ? 'nullTree' : ''}`}
			>
				{name ? (
					<>
						<span
							className={isToggled ? 'toggler' : 'toggler closed'}
							onClick={() => setIsToggled(!isToggled)}
						/>
						<File />
						<strong className="file-name-tree">&nbsp;&nbsp;{name} </strong>
						{isChildElement ? (
							info !== null ? (
								<a
									className="tree-info-size"
									onClick={() => handleClick(info[0].path)}
								>
									{info[0].items} items ({info[0].sizeInGB}GB)
									{info[0].isVerified ? (
										<HddVerifiedTrue />
									) : (
										<HddVerifiedFalse />
									)}
								</a>
							) : (
								''
							)
						) : (
							''
						)}
					</>
				) : (
					''
				)}

				{Object.keys(data).map((v, i, a) =>
					typeof data[v] === 'object' ? (
						<Tree
							key={`${name}-${v}-${i}`}
							data={data[v]}
							i={i}
							isLast={i === a.length - 1}
							name={isDataArray ? null : v}
							info={
								data[v].items
									? [
											{
												path: data[v].path,
												items: data[v].items,
												sizeInGB: data[v].sizeInGB,
												isVerified: data[v].isVerified,
											},
									  ]
									: null
							}
							isChildElement
							isParentToggled={isParentToggled && isToggled}
							hardDrive={constHardDrive}
							hardDriveID={constHardDriveID}
							contents={constContents}
							createdBy={constCreatedBy}
							path={data[v].path}
						/>
					) : (
						''
					),
				)}
			</div>
			<RecordHDDContents
				show={showModal}
				handleClose={(e) => setShowModal(false)}
				close={(e) => setShowModal(false)}
				hardDrive={constHardDrive}
				hardDriveID={constHardDriveID}
				//data={data}
				createdBy={constCreatedBy}
				contents={constContents}
				{...(constPath !== null ? { path: constPath } : {})}
				type={'edit'}
			/>
		</>
	);
};
export default Tree;
